export const jsTimestampToUnixTimestamp = (jsTimestamp: number) =>
  Math.floor(jsTimestamp / 1000)

export const unixTimestampToJsTimestamp = (unixTimestamp: number) =>
  unixTimestamp * 1000
